import { Icon, Loader, t } from "owc-react-lib-common";
import React from "react";
import { useParams } from "react-router-dom";
import { Container } from "src/components/Container";
import { Text } from "src/components/Text";
import { View } from "src/components/View";
import { Row } from "src/components/Row/Row";
import { useAlerts } from "src/hooks/useAlerts";
import { useComponentDidMount } from "src/hooks/useComponentDidMount";
import * as CompetitionSchemeService from "src/services/CompetitionSchemeService";
import { Card } from 'src/components/Card';
import { Separator } from 'src/components/Separator';
import { Title } from "src/components/Title";
import { SCHEMA_GROUP_TYPE_LEAGUE } from "../../../config";

export const SchemaDetail = () => {
  const alerts = useAlerts();
  const id = useParams().id;

  const [loading, setLoading] = React.useState<boolean>(true);
  const [data, setData] = React.useState({} as any);

  useComponentDidMount(async () => {
    try {
      const response = await CompetitionSchemeService.getScheme(id);
      setData(response.data);
    } catch (error) {
      alerts.createDSMError(error);
    }
    setLoading(false);
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <Container title={t("admin.schema.schemaDetail.title")}>
      <Title text={data?.name} />
      {data?.groups?.map((group, groupIndex) => (
        <div key={groupIndex} style={{ marginBottom: "20px", border: "1px solid #ccc", padding: "10px" }}>
          {/* Información del grupo */}
          <Row flex={[1,1,1,1,1]}>
            <View>
              <Text uppercase bold>{t("admin.schema.schemaDetail.groupName")}</Text>
              <Text>{group.groupName}</Text>
            </View>
            <View>
              <Text uppercase bold>{t("admin.schema.schemaDetail.idType")}</Text>
              <Text>{group.idType === SCHEMA_GROUP_TYPE_LEAGUE ? t("admin.schema.schemaDetail.league") : t("admin.schema.schemaDetail.knockout") }</Text>
            </View>
            <View>
              <Text uppercase bold>{t("admin.schema.schemaDetail.numRounds")}</Text>
              <Text>{group.numRounds}</Text>
            </View>
            <View>
              <Text uppercase bold>{t("admin.schema.schemaDetail.numTeams")}</Text>
              <Text>{group.numTeams}</Text>
            </View>
            <View>
              <Text uppercase bold>{t("admin.schema.schemaDetail.standingVisible")}</Text>
              <Text>{group.standingVisible === true ? t("global.yes") : t("global.no")}</Text>
            </View>
          </Row>



          <View flexDirection="row" alignItems="center" style={{ flexWrap: "wrap" }}>
            {group?.teams?.map((team, key) => (
              <View key={key} style={{ minWidth: 150 }}>
              <Card key={team.idSchemaGroup} containerStyle={{ padding: 10 }}>
                <Icon padding={0} marginRight={0} marginBottom={10} fontSize={50} type="people-group" />
                <Text textAlign='center' bold>{team?.groupName}</Text>
                <Separator marginTop={5} />
                <Text>{t("admin.schema.schemaDetail.card.bestof")}: {team.bestof}</Text>
                <Text>{t("admin.schema.schemaDetail.card.idSchemaGroup")}: {team.idSchemaGroup}</Text>
                <Text>{t("admin.schema.schemaDetail.card.idSchemaGroupTeam")}: {team.idSchemaGroupTeam}</Text>
                <Text>{t("admin.schema.schemaDetail.card.idsGroupsCompetitionSchema")}: {team.idsGroupsCompetitionSchema}</Text>
                <Text>{t("admin.schema.schemaDetail.card.position")}: {team.position}</Text>
              </Card>
              </View>
            ))}
          </View>



        </div>
      ))}
    </Container>
  );
};